export default __webpack_public_path__ + "static/media/real_estate_souq.43d79d90.jpg";